import { MinimalList } from 'adapters/list/graphqlTypes';

export const AGENT_LOADED = 'FAVOURITE_CLIENT/AGENT_LOADED';

// Events triggered from Cart and Favourites when cart and lists are updated respectively
export const UPDATE_DATA = 'TROJAN_AGENT/UPDATE_DATA';

type FavouriteItemPayload = {
    productName: string;
    productNumber: string;
    productType: string;
    quantity: string;
    ratings?: number;
};

export type InspirationPayload = {
    ids: Array<string>;
    source: string;
};

export type BuyNowPayload = {
    items: Array<{
        productNumber: string;
        quantity: string;
        uom: string;
    }>;
    source?: string;
};

type IncomingFavouritesPayload = {
    data: MinimalList[];
    source: 'favourites';
    store: string;
};
type IncomingInspirationPayload = {
    data: Array<{ id: string }>;
    source: 'inspiration';
    store: string;
};

export type UpdateDataPayload = IncomingFavouritesPayload | IncomingInspirationPayload;

type CommonAttributes = {
    source: string;
    alwaysShowModal?: boolean;
    ga?: {
        custom: any;
    };
};

export type SingleItemPayload = FavouriteItemPayload & CommonAttributes;

export type MultipleItemPayload = {
    items: Array<FavouriteItemPayload>;
} & CommonAttributes;

export type FavouritesPayload = SingleItemPayload | MultipleItemPayload;

export type FavouritesEvent = IkeaEvent<FavouritesPayload>;
export type InspirationEvent = IkeaEvent<InspirationPayload>;
export type UpdateDataEvent = IkeaEvent<UpdateDataPayload>;

export const publish = window.ikea.pubsub.publish;
